import React, { useEffect, useRef, useState } from 'react';
const _preserve = React.version;

import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { Checkbox, FormField } from '@cloudscape-design/components';
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelMovement from '../../../../../components/extras/SidePanelMovement';
import SelectAccountPlan from '../../../../../components/selects/selectAccountPlans';
import TableMovements from '../../../../../components/tables/tableMovements';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemsMovement } from '../../../../../resources/types';


export const AdminMovementsStatementsPage = () => {
    const { data, menu, parameters } = useGlobalState();
    //const storeAdmin = useStoreAdmin();
    const mountedRef = useRef(false);

    const [excludeZeroBalance, setExcludeZeroBalance] = useState(0);
    const [movements, setMovements] = useState<ItemsMovement[]>([]);
    const [movement, setMovement] = useState<Partial<ItemsMovement>>({});

    const [advanceFilter, setAdvanceFilter] = useState<boolean>(false);


    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");

            if (id) {
                handleGetMovenent(parseInt(id))
                if (!!movements)
                    handleRefreshMovements();

            } else {
                setMovement(undefined)
                if (mountedRef.current)
                    handleRefreshMovements();
            }
        };
        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();

        if (!mountedRef.current)
            mountedRef.current = true;
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);



    type ItemConecpt = {
        value: string;
        label: string;
    };
    type RawAccountPlan = {
        idAccountPlan: number;
        accountPlan: string;
    };
    const conceptItems: ItemConecpt[] = [
        { label: "DEPÓSITO DIRECTO", value: "DEPÓSITO DIRECTO" },
        { label: "TRANSFERENCIA ELECTRÓNICA", value: "TRANSFERENCIA ELECTRÓNICA" },
        { label: "CHEQUE", value: "CHEQUE" },
        { label: "TRANSBANK DEBITO", value: "TRANSBANK DEBITO" },
        { label: "TRANSBANK CREDITO", value: "TRANSBANK CREDITO" },
        { label: "EFECTIVO CLP", value: "EFECTIVO CLP" },
        { label: "EFECTIVO USD", value: "EFECTIVO USD" },
        { label: "EFECTIVO EUR", value: "EFECTIVO EUR" },
        { label: "OTRO", value: "" }
    ]


    useEffect(() => {
        //handleRefreshMovements();
    }, [parameters.dummy]); //parameters.startDate, parameters.endDate, 

    useEffect(() => {

    }, [parameters]);



    const handleGetMovenent = async (id: number) => {
        //if (parameters.startDate && parameters.endDate) {
        if (parameters.startDate && parameters.endDate) {

            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/movements/movement',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        idMovement: id,
                        columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,dateTransaction,displayName,idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK, idFlight"
                    }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    setMovement(data.movement);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }

        };
    }
    const handleRefreshMovements = async () => {
        //if (parameters.startDate && parameters.endDate) {
        if (parameters.startDate && parameters.endDate) {
            setMovements([])
            setMovement(undefined)

            try {
                setLoading(true)
                const body: any = {
                    dateStart: parameters.startDate,
                    dateEnd: parameters.endDate,
                    idAccountPlans: parameters.idAccountPlans,
                    movementType: excludeZeroBalance === 1 ? "-0" : "",
                    limit: 1000,
                    orderBy: "dateTransaction",
                    order: "desc",
                    orderBy2: "idMovement",
                    order2: "desc",
                    columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,dateTransaction,displayName,idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK, idFlight, receipt"
                };

                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/movements/list',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify(body),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    setMovements(data.movements);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }

        };
    }
    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={!!movement}
            onSplitPanelToggle={({ detail }) => !detail.open ? window.location.hash = "#admin/movements/statements" : null}
            splitPanel={movement && (
                <SidePanelMovement movement={movement ?? {}} />
            )}

            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">


                        <Header actions={
                            <SpaceBetween direction="horizontal" size="xs">

                                <Favorites />
                            </SpaceBetween>
                        }>
                            Cartola general



                        </Header>
                        <SpaceBetween direction="horizontal" size="xs">


                            <FormField label={"Cuenta contable"}>
                                <SelectAccountPlan
                                    nullOption
                                    single={false}
                                    hideTokens
                                    value={parameters.idAccountPlans ?? []}
                                    onSelect={(idAccountPlans: number[]) => setParameters({ ...parameters, idAccountPlans: idAccountPlans })}
                                />
                            </FormField>

                            <FormField label={"Excluir"}>
                                <Checkbox checked={excludeZeroBalance === 1} onChange={({ detail }) => {
                                    setExcludeZeroBalance(detail.checked ? 1 : 0);
                                }} >Movimientos con cargo/abono por $0</Checkbox>

                            </FormField>


                        </SpaceBetween>
                        <TableMovements
                            excel onSelect={(row) => {
                                window.location.hash = `#admin/movements/statements?id=${row.idMovement}`
                            }}
                            onRefresh={() => handleRefreshMovements()}
                            movements={movements} visible={true}
                            onRangeChange={(startDate, endDate) => {
                                const updatedParameters = { ...parameters, startDate: startDate, endDate: endDate, };
                                setParameters(updatedParameters);

                            }}
                        />
                    </SpaceBetween>
                </>
            }
        />
    );
};
